var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5502 2.3332C7.5502 2.63696 7.30395 2.8832 7.0002 2.8832C6.69644 2.8832 6.4502 2.63696 6.4502 2.3332C6.4502 2.02945 6.69644 1.7832 7.0002 1.7832C7.30395 1.7832 7.5502 2.02945 7.5502 2.3332ZM7.5502 6.99987C7.5502 7.30363 7.30395 7.54987 7.0002 7.54987C6.69644 7.54987 6.4502 7.30363 6.4502 6.99987C6.4502 6.69611 6.69644 6.44987 7.0002 6.44987C7.30395 6.44987 7.5502 6.69611 7.5502 6.99987ZM7.5502 11.6665C7.5502 11.9703 7.30395 12.2165 7.0002 12.2165C6.69644 12.2165 6.4502 11.9703 6.4502 11.6665C6.4502 11.3628 6.69644 11.1165 7.0002 11.1165C7.30395 11.1165 7.5502 11.3628 7.5502 11.6665Z",
    fill: "#71717A",
    stroke: "#71717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.15556695b6bf3de91c3733d4ae4c7a8a.svg";
export { ForwardRef as ReactComponent };